import React from 'react';

import type { IconProps } from './icon-types';

const AbbyChatIcon = ({ size, fill, svgStyle }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    style={{ margin: '0 auto', ...svgStyle, width: size, height: size }}
    aria-hidden="true"
  >
    <path
      fill={fill}
      d="M6.62,16.3h0A23.5,23.5,0,0,1,0,18.42a13.3,13.3,0,0,0,1.64-5.33A7.46,7.46,0,0,1,0,8.38C0,3.54,4.67,0,9.89,0s9.89,3.51,9.89,8.38c0,0.07,0,.14,0,0.21a9.37,9.37,0,0,0-2-.79C17.45,4.52,14,1.94,9.89,1.94c-4.39,0-8,2.89-8,6.44a5.64,5.64,0,0,0,1.93,4.21,17,17,0,0,1-.78,3.22,15.61,15.61,0,0,0,3.48-1.52A6.84,6.84,0,0,0,6.62,16.3ZM22,22a16.18,16.18,0,0,1-4.52-1.46c-5.24,1.29-9.06-2-9.06-5.45s3.23-5.77,6.81-5.77S22,11.76,22,15.09a5.13,5.13,0,0,1-1.16,3.24A9.15,9.15,0,0,0,22,22Zm-8.49-6.84a0.94,0.94,0,1,0-.94.94A0.94,0.94,0,0,0,13.48,15.16Zm2.79,0a0.94,0.94,0,1,0-.94.94A0.94,0.94,0,0,0,16.27,15.16Zm2.75,0a0.94,0.94,0,1,0-.94.94A0.94,0.94,0,0,0,19,15.16Z"
    ></path>
  </svg>
);

export default AbbyChatIcon;
